import React from "react";
import { useFela } from "react-fela";

import { IWithCustomStyle, useTheme } from "@/hooks/useTheme";

type IProps = JSX.IntrinsicElements["li"] & IWithCustomStyle;

export const NavbarLink: React.FC<IProps> = ({ children, customStyle }) => {
  const { css } = useFela();
  const { bp } = useTheme();

  return (
    <li
      className={css({
        cursor: "pointer",
        // containing block for the dropdown panels, so they stay anchored to
        // their own toggler instead of to the whole <nav>
        position: "relative",
        // the dropdown togglers centre their title in a flex row while a plain
        // link is inline text sitting on the list item's 16px line box strut,
        // which left the two kinds of item off by a fraction of a pixel
        display: "flex",
        alignItems: "center",
        borderBottom: "2px solid transparent",
        transition: "border-bottom-color .15s",
        margin: "5px 10px",
        [bp.TO_DESKTOP]: {
          margin: "10px 10px",
        },
        ...customStyle,
      })}
    >
      {children}
    </li>
  );
};
